import assign from 'lodash/assign'
import StepInfo from './StepInfo'
import StepSummary from './StepSummary'
import eventBus from './eventBus'

export default {
  components: {
    StepInfo,
    StepSummary,
  },

  provide() {
    return {
      provided: {
        idParamsUrl: this.idParamsUrl,
      },
    }
  },

  // language=HTML (for PhpStorm)
  template: `
    <div>
      <StepInfo 
        v-if="currentStep === 'info'" 
        :model="model" 
        :validation-rules="validationRules"
      />
      <StepSummary v-if="currentStep === 'summary'" :model="model" :save-url="url" />
    </div>
  `,

  props: {
    url: String,
    idParamsUrl: String,
  },

  data() {
    return {
      currentStep: 'info',

      model: {
        account: {
          ownership: null,
        },
        applicant: {
          firstName: null,
          middleName: null,
          lastName: null,
          dateOfBirth: null,
          ssn: null,
          idFile: null,
          driversLicense: {
            number: null,
            state: null,
          },
          phone: {
            home: null,
            cell: null,
          },
          email: null,
          serviceAddress: {
            street: null,
            street2: null,
            city: null,
            state: null,
            zip: null,
          },
          mailingAddress: {
            isDifferentThanService: false,
            street: null,
            street2: null,
            city: null,
            state: null,
            zip: null,
          },
          employer: {
            name: null,
            phone: null,
          },
          ownOrRent: null,
          landlord: {
            name: null,
            phone: null,
          },
        },
        coapplicant: {
          firstName: null,
          middleName: null,
          lastName: null,
          dateOfBirth: null,
          ssn: null,
          driversLicense: {
            number: null,
            state: null,
          },
        },
        service: {
          startDate: null,
          type: null,
          comments: null,
          hasRemcOutdoorLight: null,
          wantsOutdoorLight: null,
          previousService: {
            hadService: null,
            address: null,
          },
          typeOfHome: null,
          preferredBillingMethod: null,
        },
        termsAndConditions: {
          accepts: null,
          understandsElectronicSignature: null,
          signature: null,
        },
        capitalFund: {
          enroll: null,
          signature: null,
        },
      },
    }
  },

  computed: {
    validationRules() {
      const rules = {
        account: {
          ownership: [this.requiredRule],
        },
        applicant: {
          firstName: [this.requiredRule],
          middleName: [this.requiredRule],
          lastName: [this.requiredRule],
          dateOfBirth: [this.requiredRule],
          ssn: [this.requiredRule],
          idFile: [this.requiredRule],
          driversLicense: {
            number: [this.requiredRule],
            state: [this.requiredRule],
          },
          phone: {
            home: [this.requiredRule],
            cell: [this.requiredRule],
          },
          email: [this.emailRule],
          serviceAddress: {
            street: [this.requiredRule],
            street2: [],
            city: [this.requiredRule],
            state: [this.requiredRule],
            zip: [this.requiredRule],
          },
          employer: {
            name: [],
            phone: [],
          },
          ownOrRent: [this.requiredRule],
        },
      }

      if (this.model.applicant.ownOrRent === 'Rent') {
        rules.applicant.landlord = {
          name: [this.requiredRule],
          phone: [this.requiredRule],
        }
      }

      if (this.model.applicant.mailingAddress.isDifferentThanService) {
        assign(rules.applicant, {
          mailingAddress: {
            street: [this.requiredRule],
            street2: [],
            city: [this.requiredRule],
            state: [this.requiredRule],
            zip: [this.requiredRule],
          },
        })
      }

      rules.coapplicant = {
        firstName: [this.requiredRule],
        middleName: [this.requiredRule],
        lastName: [this.requiredRule],
        dateOfBirth: [this.requiredRule],
        ssn: [this.requiredRule],
        driversLicense: {
          number: [this.requiredRule],
          state: [this.requiredRule],
        },
      }

      rules.service = {
        startDate: [this.requiredRule],
        type: [],
        previousService: {
          hadService: [this.requiredRule],
          address: [],
        },
        preferredBillingMethod: [this.requiredRule],
      }

      rules.termsAndConditions = {
        accepts: [this.requiredRule],
        understandsElectronicSignature: [this.requiredRule],
        signature: [this.requiredRule],
      }

      if (this.model.service.previousService.hadService === 'Yes') {
        rules.service.previousService.address = [this.requiredRule]
      }

      rules.capitalFund = {
        enroll: [this.requiredRule],
        signature: [this.requiredRule],
      }

      return rules
    },
  },

  methods: {
    onNextStep() {
      if (this.currentStep === 'info') {
        this.currentStep = 'summary'
        window.scrollTo(0, 0)
      }
    },

    onPrevStep() {
      if (this.currentStep === 'summary') {
        this.currentStep = 'info'
        window.scrollTo(0, 0)
      }
    },
  },

  created() {
    this.requiredRule = { required: true, message: 'Required' }
    this.emailRule = { type: 'email', required: true, message: 'Please enter your email address.' }

    eventBus.$on('next-step', this.onNextStep)
    eventBus.$on('prev-step', this.onPrevStep)
  },
}
